import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";

export default function XlbutorHome({ onNavigate }) {
  const [mapModalOpen, setMapModalOpen] = useState(false);

  useEffect(() => {
    // Initialize Feather icons
    if (window.feather) {
      window.feather.replace();
    }
  }, []);

  const openMapModal = () => {
    setMapModalOpen(true);
  };

  const closeMapModal = () => {
    setMapModalOpen(false);
  };

  return (
    <div>


      {/* Categories Section */}
      <section className="py-8 sm:py-10 md:py-12">
        <div className="container mx-auto px-4 sm:px-6">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-5 sm:mb-6 md:mb-8 text-center text-gray-900 animated-underline">
            Amit nálunk megtalálsz
          </h2>
        </div>

        {/* Mobile: Horizontal Scroll | Desktop: Grid */}
        <div className="md:hidden overflow-x-auto scrollbar-hide px-4">
          <div className="flex gap-4 pb-4" style={{ scrollSnapType: 'x mandatory' }}>
            <div className="category-card group flex-shrink-0 w-[140px]" style={{ scrollSnapAlign: 'start' }}>
              <div className="overflow-hidden rounded-lg shadow-md">
                <img 
                  src="/images/Weboldalképei/szonyegek.jpg" 
                  alt="Szőnyegek" 
                  className="w-full h-36 object-cover"
                  loading="lazy"
                />
              </div>
              <h3 className="mt-2 text-center text-sm font-medium text-gray-900">Szőnyegek</h3>
            </div>
            <div className="category-card group flex-shrink-0 w-[140px]" style={{ scrollSnapAlign: 'start' }}>
              <div className="overflow-hidden rounded-lg shadow-md">
                <img 
                  src="/images/Weboldalképei/haztartasieszkozok.png" 
                  alt="Háztartási eszközök" 
                  className="w-full h-36 object-cover"
                  loading="lazy"
                />
              </div>
              <h3 className="mt-2 text-center text-sm font-medium text-gray-900">Háztartási eszközök</h3>
            </div>
            <div className="category-card group flex-shrink-0 w-[140px]" style={{ scrollSnapAlign: 'start' }}>
              <div className="overflow-hidden rounded-lg shadow-md">
                <img 
                  src="/images/Weboldalképei/laksadekor.jpg" 
                  alt="Lakásdekor" 
                  className="w-full h-36 object-cover"
                  loading="lazy"
                />
              </div>
              <h3 className="mt-2 text-center text-sm font-medium text-gray-900">Lakásdekor</h3>
            </div>
            <div className="category-card group flex-shrink-0 w-[140px]" style={{ scrollSnapAlign: 'start' }}>
              <div className="overflow-hidden rounded-lg shadow-md">
                <img 
                  src="/images/Weboldalképei/szerszamok.png" 
                  alt="Szerszámok" 
                  className="w-full h-36 object-cover"
                  loading="lazy"
                />
              </div>
              <h3 className="mt-2 text-center text-sm font-medium text-gray-900">Szerszámok</h3>
            </div>
          </div>
        </div>

        {/* Desktop Grid */}
        <div className="hidden md:block container mx-auto px-4 sm:px-6">
          <div className="mx-auto max-w-5xl grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 justify-items-center">
            <div className="category-card group">
              <div className="overflow-hidden rounded-lg shadow-md">
                <img 
                  src="/images/Weboldalképei/szonyegek.jpg" 
                  alt="Szőnyegek" 
                  className="w-full h-40 md:h-48 object-cover"
                  loading="lazy"
                />
              </div>
              <h3 className="mt-3 text-center font-medium text-gray-900">Szőnyegek</h3>
            </div>
            <div className="category-card group">
              <div className="overflow-hidden rounded-lg shadow-md">
                <img 
                  src="/images/Weboldalképei/haztartasieszkozok.png" 
                  alt="Háztartási eszközök" 
                  className="w-full h-40 md:h-48 object-cover"
                  loading="lazy"
                />
              </div>
              <h3 className="mt-3 text-center font-medium text-gray-900">Háztartási eszközök</h3>
            </div>
            <div className="category-card group">
              <div className="overflow-hidden rounded-lg shadow-md">
                <img 
                  src="/images/Weboldalképei/laksadekor.jpg" 
                  alt="Lakásdekor" 
                  className="w-full h-40 md:h-48 object-cover"
                  loading="lazy"
                />
              </div>
              <h3 className="mt-3 text-center font-medium text-gray-900">Lakásdekor</h3>
            </div>
            <div className="category-card group">
              <div className="overflow-hidden rounded-lg shadow-md">
                <img 
                  src="/images/Weboldalképei/szerszamok.png" 
                  alt="Szerszámok" 
                  className="w-full h-40 md:h-48 object-cover"
                  loading="lazy"
                />
              </div>
              <h3 className="mt-3 text-center font-medium text-gray-900">Szerszámok</h3>
            </div>
          </div>
        </div>
      </section>

      {/* CTA to Works Page */}
      <section className="py-6 sm:py-8 md:py-10">
        <div className="container mx-auto px-4 sm:px-6 text-center">
          <div className="bg-gradient-to-r from-gray-900 to-gray-700 text-white rounded-xl shadow-xl p-6 sm:p-8 md:p-10 flex flex-col items-center gap-4">
            <h3 className="text-xl sm:text-2xl md:text-3xl font-bold">Nézd meg a munkáinkat</h3>
            <p className="text-sm sm:text-base text-gray-200 max-w-2xl">Válogatott referenciák kész konyhákról, nappalikról és egyedi bútorkészítésekről.</p>
            <button
              onClick={() => onNavigate('munkaink')}
              className="mt-2 inline-flex items-center gap-2 bg-white text-gray-900 px-5 py-2.5 sm:px-6 sm:py-3 rounded-lg font-semibold shadow hover:bg-gray-100 active:bg-gray-200 transition-all duration-300 group gentle-pulse"
            >
              Fedezd fel a Munkáink oldalt
              <span 
                className="arrow-animate group-hover:translate-x-1 group-hover:scale-110"
                aria-hidden
              >
                →
              </span>
            </button>
          </div>
        </div>
      </section>

      {/* Split Banner Section */}
      <section className="container mx-auto px-4 sm:px-6 py-6 sm:py-8 md:py-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-6">
          <div 
            className="relative overflow-hidden rounded-xl shadow-lg group cursor-pointer"
            onClick={() => onNavigate('rolunk')}
          >
            <img 
              src="/images/Weboldalképei/513502099_23889229397400221_4984633965961444247_n.jpg" 
              alt="Rólunk" 
              className="w-full h-48 sm:h-64 md:h-72 lg:h-80 object-cover transition-transform duration-500 group-hover:scale-105"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-black/20" />
            <div className="absolute inset-0 flex items-center justify-center">
              <h3 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight">
                Rólunk
              </h3>
            </div>
          </div>
          <div 
            className="relative overflow-hidden rounded-xl shadow-lg group cursor-pointer"
            onClick={openMapModal}
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3635.363597307089!2d22.06848371281099!3d48.20644487113132!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4738ecd91b133f8f%3A0x7d51328ff4086370!2zWEwgQsO6dG9yLCBTesWRbnllZyBWZWd5ZXNrZXJlc2tlZMOpcw!5e1!3m2!1shu!2shu!4v1761558750278!5m2!1shu!2shu"
              width="100%"
              height="320"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-full h-48 sm:h-64 md:h-72 lg:h-80"
              title="XL bútor - Kisvárda Location"
            ></iframe>
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-5 md:p-6 text-white">
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold mb-2 sm:mb-3 leading-tight text-center md:text-left">
                Térkép
              </h3>
            </div>
          </div>
        </div>
      </section>


      {/* Search Modal */}
      <div id="searchModal" className="fixed inset-0 bg-black bg-opacity-50 z-50 hidden">
        <div className="relative w-full max-w-2xl mx-auto mt-32">
          <div className="bg-white rounded-lg shadow-lg p-4">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold">Keresés</h3>
              <button onClick={() => document.getElementById('searchModal').classList.add('hidden')} className="text-gray-500 hover:text-gray-700">
                <i data-feather="x"></i>
              </button>
            </div>
            <div className="flex">
              <input type="text" placeholder="Mit keresel?" className="flex-grow px-4 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-black" />
              <button className="bg-black text-white px-6 py-2 rounded-r-md hover:bg-gray-800">Keresés</button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div id="mobileMenu" className="fixed inset-0 bg-black bg-opacity-50 z-50 hidden md:hidden">
        <div className="bg-white h-full w-80 right-0 absolute">
          <div className="p-4 flex justify-between items-center border-b">
            <h3 className="font-bold">Menü</h3>
            <button onClick={() => document.getElementById('mobileMenu').classList.add('hidden')} className="text-gray-500 hover:text-gray-700">
              <i data-feather="x"></i>
            </button>
          </div>
          <div className="p-4 space-y-4">
            <a href="/products.html" className="block hover:text-gray-600">Termékek</a>
            <a href="/inspiration.html" className="block hover:text-gray-600">INSPIRÁCIÓ</a>
            <a href="/new.html" className="block hover:text-gray-600">ÚJ</a>
            <a href="/christmas.html" className="block hover:text-gray-600">KARÁCSONY</a>
            <a href="/deals.html" className="block hover:text-gray-600">AJÁNLATOK</a>
          </div>
        </div>
      </div>
      
      {/* Map Modal */}
      {mapModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
            {/* Modal Header */}
            <div className="flex justify-between items-center p-4 border-b">
              <h3 className="text-xl font-bold text-gray-900">XL bútor - Kisvárda</h3>
              <button 
                onClick={closeMapModal}
                className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
              >
                ×
              </button>
            </div>
            
            {/* Map Content */}
            <div className="relative">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3635.363597307089!2d22.06848371281099!3d48.20644487113132!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4738ecd91b133f8f%3A0x7d51328ff4086370!2zWEwgQsO6dG9yLCBTesWRbnllZyBWZWd5ZXNrZXJlc2tlZMOpcw!5e1!3m2!1shu!2shu!4v1761558750278!5m2!1shu!2shu"
                width="100%"
                height="500"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="XL bútor - Kisvárda Location"
              ></iframe>
            </div>
          </div>
        </div>
      )}

      {/* Footer */}
      <Footer />
    </div>
  );
}